export default __webpack_public_path__ + "static/media/m_wdt_c_1.b35235f0.mp3";